import { createReducer, on } from "@ngrx/store";
import * as Actions from "./actions";
import { RevisionStatusStateInterface } from "src/app/revisions/models/revisionStatusStateInterface";

export const initialState: RevisionStatusStateInterface = {
    isLoading: false,
    revisionStatus: [],
    notFinalRevisionStatus: [],
    error: null,
};

export const revisionStatusReducers = createReducer(
    initialState, 

    // Get Revision Status
    on(Actions.getRevisionStatus, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.getRevisionStatusSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        revisionStatus: action.revisionStatus.slice().sort((a, b) => a.index - b.index)
    })),
    on(Actions.getRevisionStatusFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Create Revision Status
    on(Actions.createRevisionStatus, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.createRevisionStatusSuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        revisionStatus: [...state.revisionStatus, action.revisionStatus].sort((a, b) => a.index - b.index)
    })),
    on(Actions.createRevisionStatusFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Update Revision Status
    on(Actions.updateRevisionStatus, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.updateRevisionStatusSuccess, (state, action) => {
        const updatedRevisionStatusIndex = state.revisionStatus.findIndex(revisionStatus => revisionStatus.id === action.revisionStatus.id);
        
        if (updatedRevisionStatusIndex === -1) {
            return state;
        }

        const updatedRevisionStatus = [...state.revisionStatus];
        updatedRevisionStatus[updatedRevisionStatusIndex] = action.revisionStatus;

        return {
            ...state,
            isLoading: false,
            revisionStatus: updatedRevisionStatus.sort((a, b) => a.index - b.index)
        };
    }),
    on(Actions.updateRevisionStatusFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Delete Revision Status
    on(Actions.deleteRevisionStatus, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.deleteRevisionStatusSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        revisionStatus: state.revisionStatus.filter(category => category.id !== action.id)
      })),
    on(Actions.deleteRevisionStatusFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);